import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getDiscussChatHistoryForDocument } from "../services/discuss.service";
import type { ChatHistoryResponse } from "../types/discuss.types";
import { mergeDiscussHistory } from "./discuss-chat.utils";

/**
 * Hook to fetch and manage chat history for a document.
 *
 * Do not use keepPreviousData here. Same-key refetches already keep `data`,
 * and leftover pending turns are merged in queryFn. keepPreviousData would
 * show another document's chat while the new documentId is fetching.
 */
export const useDiscussHistory = (documentId?: string) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["chatHistory", documentId],
    queryFn: async () => {
      const incoming = await getDiscussChatHistoryForDocument(documentId ?? "");
      const cached = queryClient.getQueryData<ChatHistoryResponse>(["chatHistory", documentId]);
      return mergeDiscussHistory(cached, incoming);
    },
    enabled: !(documentId == null), // Only run the query if documentId is provided
  });
};
